import { render, staticRenderFns } from "./IconArrowTopLong.vue?vue&type=template&id=26bbfc32"
import script from "./IconArrowTopLong.vue?vue&type=script&lang=js"
export * from "./IconArrowTopLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports